export enum TransformationType {
    HEIGHT = 'HEIGHT',
    WIDTH = 'WIDTH',
    PADDING = 'PADDING',
    BG_REMOVE = 'BG_REMOVE',
    BG_CLR = 'BG_CLR',
    BG_IMG = 'BG_IMG',
    CROP = 'CROP',
    QUALITY = 'QUALITY',
    FORMAT = 'FORMAT',
    GRAY_EFFECT = 'GRAY_EFFECT',
}
